import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize';
import { withTranslation } from 'react-i18next';
import { translate, convertToDecimal, convertToSeparator, formatData } from '../../../utils/util';
import { BackButton } from '../../../components/UI/ComponentsUI';

const LogListDetail = (props) => {
    const { selectedLog } = props;

    useEffect(() => {
        M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        // eslint-disable-next-line
    }, []);

    const formatJson = (jsonText) => {
        try {
            return JSON.stringify(JSON.parse(jsonText), null, 2);

        } catch (error) {
            console.error("JSON inválido");
            return jsonText;
        }
    }

    return (
        <>
            <BackButton {...props} />
            <div className="container-fluid"  >
                <div className="container">
                    <div className="row" style={{ marginBottom: '0px' }}>
                        <div className="input-field no-padding col s12">
                            <b className="field f-1r">{`${translate('physical-confirmation:mvm')}: ${convertToSeparator(selectedLog.mvmNumber) || ''}`}</b>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r">{`${translate('physical-confirmation:journey')}: ${convertToDecimal(selectedLog.journey) || ''}`}</span>
                        </div>
                        <div className="input-field no-padding col s12">
                            <span className="field f-1r">{`${formatData(selectedLog.createdOn)}`}</span>
                        </div>
                    </div>
                    <div className="row" style={{ marginBottom: '0px' }}>
                        <ul id='collapsible1' className="collapsible">
                            <li className='active'>
                                <div className="collapsible-header">
                                    JSON REQUEST:
                                </div>
                                <div className="collapsible-body" style={{ padding: '10px' }}>
                                    <pre className="field f-1r" style={{ padding: '0px', wordWrap: 'break-word' }}>{formatJson(selectedLog?.jsonRequest)}</pre>
                                </div>
                            </li>
                        </ul>
                        <ul id='collapsible2' className="collapsible">
                            <li className='active'>
                                <div className="collapsible-header">
                                    JSON RESPONSE:
                                </div>
                                <div className="collapsible-body" style={{ padding: '10px' }}>
                                    <pre className="field f-1r" style={{ padding: '0px', wordWrap: 'break-word' }}>{formatJson(selectedLog?.jsonResponse)}</pre>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="input-field no-padding col s12">
                        <div>{translate('physical-confirmation:return')}: {selectedLog.success ? translate('physical-confirmation:success') : translate('physical-confirmation:fail')}</div>
                    </div>

                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        selectedLog: state.logReducer.selectedLog
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogListDetail));

